import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import {
  Breadcrumb,
  Table,
  Descriptions,
  Steps,
  Button,
  Divider,
  Spin,
  Typography,
  message,
  Modal,
} from 'antd'
import {
  titleText,
  breadcrumbItem,
  stepItems,
  stepCurrents,
  orderColumns,
} from './config'
import { CartAnotherOrder } from 'components'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/order'
import { add } from '@sisyphe/utils'
import './index.less'

const { Title } = Typography

export default function Detail() {
  const params: { orderNo: string } = useParams()

  /*我的订单-订单详情 */
  const {
    run: queryMyOderDetailsUsingPOST,
    data: detail,
    loading,
  } = useRequest(async () => {
    const { data } = await api.queryMyOderDetailsUsingPOST(params)
    return data
  })

  /**我的订单-确认收货 */
  const { run: confirmReceiptUsingPOST } = useRequest(
    async () => {
      await api.confirmReceiptUsingPOST(params)
      message.success('操作成功')
      queryMyOderDetailsUsingPOST()
    },
    { manual: true }
  )

  // 确认收货
  const confirm = () => {
    Modal.confirm({
      title: '提示',
      content: '确认收到货了吗？',
      onOk() {
        confirmReceiptUsingPOST()
      },
    })
  }

  const totalAmount = useMemo(() => {
    return detail?.goods?.reduce((num, item) => {
      return add(num, item?.actualPay) as number
    }, 0)
  }, [detail?.goods])

  return (
    <Spin spinning={loading}>
      <div className="order-detail">
        <Breadcrumb items={breadcrumbItem} />
        <Title level={4}>{titleText[detail?.status!]}</Title>
        <div className="order-detail-content">
          <Steps
            current={stepCurrents[detail?.status!]}
            items={stepItems({
              orderInfo: detail,
            })}
          />
          <div className="order-detail-options">
            <CartAnotherOrder orderNo={detail?.orderNo}>
              <Button type="primary">再来一单</Button>
            </CartAnotherOrder>
            {detail?.status === 5 && (
              <Button type="primary" onClick={confirm}>
                确认收货
              </Button>
            )}
          </div>
          <Divider />
          <Descriptions title="订单信息" column={4}>
            <Descriptions.Item label="订单编号">
              {detail?.orderNo}
            </Descriptions.Item>
            <Descriptions.Item label="员工账号编码">
              {detail?.userAccountCode}
            </Descriptions.Item>
            <Descriptions.Item label="员工电话">
              {detail?.mobile}
            </Descriptions.Item>
            <Descriptions.Item label="员工姓名">
              {detail?.userAccountName}
            </Descriptions.Item>
            <Descriptions.Item label="企业全称">
              {detail?.enterpriseName}
            </Descriptions.Item>
            <Descriptions.Item label="下单时间">
              {detail?.submitTime}
            </Descriptions.Item>
            <Descriptions.Item label="订单应付额度">
              {detail?.orderAmount?.toFixed(2)}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions title="收货信息" column={4}>
            <Descriptions.Item label="收货人">
              {detail?.consigneeMan}
            </Descriptions.Item>
            <Descriptions.Item label="收货电话">
              {detail?.consigneeMobile}
            </Descriptions.Item>
            <Descriptions.Item label="收货地址">
              {detail?.provinceName}
              {detail?.cityName}
              {detail?.areaName}
              {detail?.consigneeAddress || detail?.address}
            </Descriptions.Item>
          </Descriptions>
          <Divider />
          <Descriptions title="采购单明细" />
          <Table
            columns={orderColumns}
            dataSource={detail?.goods || []}
            pagination={false}
          />
          <p className="order-detail-limit">
            应付总额度：{detail?.orderAmount?.toFixed(2)}
          </p>
          <p className="order-detail-limit order-detail-total">
            实付总额度：{totalAmount}
          </p>
          <Divider />
          <Descriptions title="其他信息">
            <Descriptions.Item label="订单备注">
              {detail?.remark}
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    </Spin>
  )
}
